<template lang="pug">
  .component-selectize-driver
    selectize(v-if="options", :selectedValue="selectedValue" :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Cards")
</template>

<script>
  import Selectize from "../../../Selectize"
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice"

  export default {
    name: "SelectizeCard",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>${item.id}</small></div><div>${item.name}</div></div>`
      },
      dataLoader(page, resultsPerPage, search) {
        if (this.nullDriver) {
          KeplerBackofficeSdk.cards.list(page, resultsPerPage, search).unassigned((data) => {
            this.options = data.items
          })
        } else {
          KeplerBackofficeSdk.cards.list(page, resultsPerPage, search).all((data) => {
            this.options = data.items
          })
        }
      },
      renderTemplate(item, escape) {
        return `<div>${item.name}</div>`
      }
    },
    props: ['selectedValue','nullDriver']
  }
</script>

<style></style>



// WEBPACK FOOTER //
// SelectizeCard.vue?a8f70286